import $ from "jquery";
import "select2";
import Choices from "choices.js";

const selectors = {
	select2: {
		container: "[data-custom-select]",
		dropdownHolder: "[data-custom-select-dropdown]"
	},
	choices: {
		container: "[data-custom-choices]"
	}
};

const attributes = {
	select2: {
		selectPlaceholder: "data-custom-select-placeholder"
	},
	choices: {
		selectPlaceholder: "data-custom-choices-placeholder"
	}
};

(function () {
	let $selects = $(selectors.select2.container);
	let $choices = $(selectors.choices.container);

	if (!$selects.length && !$choices.length) {
		return null;
	}

	$selects.each(initCustomSelect2);
	$choices.each(initCustomChoices);

	function initCustomSelect2() {
		let $select = $(this);
		let placeholderValue = $select.attr(
			attributes.select2.selectPlaceholder
		);

		let options = {
			dropdownParent: $select.siblings(selectors.select2.dropdownHolder),
			minimumResultsForSearch: -1
		};

		if (placeholderValue) {
			options.placeholder = placeholderValue;
		}

		$select.select2(options);
	}

	function initCustomChoices() {
		let select = this;
		let placeholderValue = $(select).attr(
			attributes.choices.selectPlaceholder
		);

		let options = {
			searchEnabled: false,
			shouldSort: false,
			itemSelectText: ""
		};

		if (placeholderValue) {
			options.placeholder = true;
			options.placeholderValue = placeholderValue;
		}

		new Choices(select, options);
	}
})();
